"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CategoryLink = void 0;

var _preact = require("preact");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _trackingLink = _interopRequireDefault(require("../link/tracking-link"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _ChevronRight = _interopRequireDefault(require("@insided/shared/icons/ChevronRight"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["isNested", "topicsCount", "isHamburger", "children", "external"];

var Link = function Link(props) {
  return (0, _preact.h)(_trackingLink.default, (0, _extends2.default)({}, props, {
    className: "main-menu-link link--text"
  }), props.children);
};

/**
 * Renders a chevron icon pointing in the specified direction
 */
var ChevronIcon = function ChevronIcon(_ref) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'right' : _ref$direction;

  if (direction === 'down') {
    return (0, _preact.h)(_ChevronDown.default, {
      width: 16,
      height: 16
    });
  }

  return (0, _preact.h)(_ChevronRight.default, {
    width: 16,
    height: 16
  });
};

var CategoryLink = function CategoryLink(props) {
  var isNested = props.isNested,
      topicsCount = props.topicsCount,
      isHamburger = props.isHamburger,
      children = props.children,
      external = props.external,
      restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  return (0, _preact.h)(_trackingLink.default, (0, _extends2.default)({}, restProps, {
    target: external ? '_blank' : '',
    rel: external ? 'noreferrer noopener' : '',
    className: (0, _classnames.default)('link--text', 'main-menu-link', 'main-menu-link--category', {
      'main-menu-link--category--nested': isNested,
      'main-menu-link--category--hamburger': isHamburger
    })
  }), (0, _preact.h)("span", {
    className: "main-menu-link__name"
  }, children), isNested ? (0, _preact.h)(ChevronIcon, {
    direction: isHamburger ? 'down' : 'right'
  }) : (0, _preact.h)("span", {
    className: "text--meta"
  }, topicsCount));
};

exports.CategoryLink = CategoryLink;
var _default = Link;
exports.default = _default;